//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import goBack from '@/components/public-components/goBack/index.vue'
import mapList from '@/components/public-components/mapList/index.vue'
import Footer from "@/components/lyx-components/lyx-footer/index"

export default {
    name: 'culture',
    components: {
        goBack,
        mapList,
        Footer
    },
    data() {
        return {
            showMedia: 'img',
            showMapList: false,
            minHeight: 0,
            mapNav: { title: "123" },
            row: {
                'heritageEntity': {
                    title: '',
                    content: ''
                }
            }
        }
    },
    watch: {
        '$route': function (to, from) {
        }
    },
    mounted() {
        this.minHeight = document.documentElement.clientHeight
        this.getRow()
    },
    methods: {
        updateShowMedia(media) {
            this.showMedia = media
        },
        getRow() {
            let _this = this
            // 详情
            this.$http.get("/api/wtcp-bics/public/heritage/findHotelInfoById/" + this.$route.query.id).then(res => {
                _this.row = res.data.data
                _this.row.bannerList = res.data.data.fileList.image.all.materials.map(item => {
                    return _this.PIC_BASE_URL + item.fileUrl
                })
                console.log(_this.row.bannerList)
                document.title = _this.row.heritageEntity.title
            })
        },
        goPage(path) {
            this.$router.push({ path })
        },
        phone(number) {
            window.location.href = 'tel:' + number
        }
    }
}
